import type { VoidFunctionComponent } from 'react';

import { ButtonGroup, LoaderButton } from '../generic/Button';
import Flex from '../generic/Flex';
import LabeledCheckbox from '../generic/Forms/LabeledCheckbox';
import SearchInput from '../generic/Forms/SearchInput';
import { icons } from '../generic/Icon';
import type { TextInputOnChange } from '../generic/Forms/InputBase';

type RawVulnEditHeaderProps = {
  onSearchChange: TextInputOnChange;
  onToggleLinuxFilter: () => void;
  search: string;
  shouldFilterLinux: boolean;
  onSave: () => void;
  isLoading: boolean;
  isSaveDisabled: boolean;
};

const RawVulnEditHeader: VoidFunctionComponent<RawVulnEditHeaderProps> = ({
  onSearchChange,
  search,
  shouldFilterLinux,
  onToggleLinuxFilter,
  onSave,
  isLoading,
  isSaveDisabled,
}) => {
  return (
    <div className="panel">
      <div className="panel-body padded-small">
        <Flex justify="space-between" gap={50}>
          <span className="raw-vulns-search">
            <SearchInput
              label="RawVuln Search"
              placeholder="Search by Package, CVE, or Fetcher..."
              onChange={onSearchChange}
              value={search}
            />
          </span>
          <ButtonGroup spacing="md">
            <LabeledCheckbox
              label="Filter Out Linux"
              isChecked={shouldFilterLinux}
              onChange={onToggleLinuxFilter}
            />
            <LoaderButton
              type="primary"
              size="medium"
              icon={icons.save}
              isLoading={isLoading}
              isDisabled={isSaveDisabled}
              onClick={onSave}
            >
              Save Changes
            </LoaderButton>
          </ButtonGroup>
        </Flex>
      </div>
    </div>
  );
};

export default RawVulnEditHeader;
